(() => {
  let facetsLoaded = false;

  function loadFacets() {
    if (facetsLoaded || !window.FACETS_SCRIPT_URL) return;
    facetsLoaded = true;

    console.log("✅ facets.js carregado após FoxTheme estar pronto");
    const script = document.createElement("script");
    script.src = window.FACETS_SCRIPT_URL;
    script.defer = true;
    document.body.appendChild(script);
  }

  function waitForFoxTheme(retries = 20) {
    if (window.FoxTheme && FoxTheme.pubsub) {
      loadFacets();
    } else if (retries > 0) {
      setTimeout(() => waitForFoxTheme(retries - 1), 200);
    } else {
      console.warn("⚠️ FoxTheme não ficou disponível — facets.js não foi carregado.");
    }
  }

  document.addEventListener("DOMContentLoaded", () => waitForFoxTheme());
})();
